/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { ReactNode, useState } from "react";
import Hidden from "@mui/material/Hidden";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import GradientPaper from "../GradientComponents/GradientPaper";
import { Box, Theme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import expandablePaperStyle from "./expandablePaperStyle";

type ExpandablePaperProps = {
  header: string;
  children: ReactNode;
};

const ExpandablePaper = ({ header, children, ...rest }: ExpandablePaperProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isXs = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const displayMode = isXs && !isExpanded ? "none" : "block";

  const togglePaper = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <GradientPaper sx={expandablePaperStyle.paper} {...rest}>
      <Typography variant={"h3"} sx={expandablePaperStyle.heading}>
        {header}
      </Typography>
      <Box sx={{ display: displayMode }}>{children}</Box>
      <Hidden implementation={"css"} smUp>
        <Button color={"primary"} onClick={togglePaper}>
          {isExpanded ? "Weniger anzeigen" : "Mehr erfahren"}
        </Button>
      </Hidden>
    </GradientPaper>
  );
};

export default ExpandablePaper;
